<template>
    <div class="d-flex flex-column w-100">
		<nav-bar/>
		<banner titulo="Arquivos" subTitulo="Download e envio de arquivos"/>
        <div class="d-flex flex-column w-75 mx-auto mt-2 p-md-5 p-3 borda gap-md">
			<b-row class="h-50">
				<b-col cols="12">
                	<b-button variant="primary" @click="$bvModal.show('modal-upload-arquivo-usuario-externo')">Envie Arquivos Para a Primeseg</b-button>
            	</b-col>
				<modal-upload-arquivos-usuario-externo/>
			</b-row>
			<b-row>
				<b-col cols="12">
					<h2 class="mt-3">Arquivos Recebidos:</h2>
				</b-col>
			</b-row>
            <b-table striped hover :items="arquivos" :fields="fields" show-empty :responsive="true" :busy="carregando">
                <template #empty >
                    <div class="d-flex">
                    	<span class="mx-auto">
                    	Nenhum Arquivo Encontrado
                    	</span>
                    </div>
                </template>
                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                    </div>
                </template>
                <template #cell(index)="data">
                    {{ data.index + 1 }}
                </template>
                <template #cell(nome)="data">{{ data.item.nome + data.item.extensao }}</template>
                <template #cell(dataInicio)="data">{{  $options.filters.moment(data.item.dataInicio).format("DD/MM/YYYY HH:mm") }}</template>
				<template #cell(acao)="data">
                    <b-button variant="secondary" @click="baixarArquivo(data.item.id)">Download</b-button>
				</template>
            </b-table>
            <b-pagination @input="consultarArquivosPorUsuario" class="mx-auto" v-model="paginaAtualTabelaArquivos" :total-rows="numeroDeLinhasTabelaArquivos" :per-page="arquivosPorPagina"></b-pagination>
        </div>
    </div>
</template>

<script>
import ModalUploadArquivosUsuarioExterno from "../../components/GerenciarArquivosPrimeseg/ModalUploadArquivosUsuarioExterno.vue";

import Banner from "../../components/shared/Banner.vue";
import NavBar from "../../components/shared/NavBar.vue";
import ArquivoUsuarioService from "../../service/ArquivoUsuarioService.js";


export default {
	components: { Banner, ModalUploadArquivosUsuarioExterno, NavBar },
	name: "Arquivos",
 		data() {
		return {
			carregando: false,
			arquivos: [],
			fields: [
				{ label: "#", key: "index" },
			 	{ label: "Arquivo", key: "nome" },
			 	{ label: "Descrição", key: "descricao" },
				{ label: "Data/Hora de Envio Do Arquivo", key: "dataInicio" },
				{ label: "", key: "acao" },
			],
			numeroDeLinhasTabelaArquivos: 0,
			paginaAtualTabelaArquivos: 1,
			arquivosPorPagina: 15,
		};
	},
	created() {
		this.filtrarArquivos();
	},
	methods: {
		filtrarArquivos() {
			this.paginaAtualTabelaArquivos = 1;
			this.consultarArquivosPorUsuario();
		},
		consultarArquivosPorUsuario() {
			this.carregando = true;
			const usuarioLogado = JSON.parse(localStorage.getItem("usuario"));
			ArquivoUsuarioService.consultarArquivosPorUsuario(usuarioLogado.id, this.paginaAtualTabelaArquivos - 1, this.arquivosPorPagina).then((res) => {
				this.arquivos = res.data[0];
				this.numeroDeLinhasTabelaArquivos = res.data[1];
			}).catch(() => {
				this.mensagem("Não foi possível consultar os arquivos do usuário nesse momento", "Erro", "danger");
			}).finally(() => {
				this.carregando = false;
			});
		},
		baixarArquivo(id) {
			this.carregando = true;
			ArquivoUsuarioService.baixar(id).then((res) => {
				this.$fileUtils.baixarArquivo(res.data.arquivo, res.data.nome);
				this.mensagem("Download do arquivo realizado com sucesso !", "Sucesso", "success");
			}).catch((err) => {
				console.log(err);
				if (err.response) {
					this.mensagem(err.response.data, "Erro", "danger");
				} else {
					this.mensagem("Não foi possível realizar o download do arquivo nesse momento", "Erro", "danger");
				}
			}).finally(() => {
				this.carregando = false;
			});
		},
		mensagem(msg, titulo, variant) {
			this.$bvToast.toast(msg, {
				title: titulo,
				autoHideDelay: 6000,
				appendToast: true,
				variant,
				toaster: "b-toaster-bottom-right",
			});
		},
	},
};
</script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.borda {
    box-shadow: 0px 0px 2px 0px grey;
    min-height: 80vh;
}
</style>




// WEBPACK FOOTER //
// src/views/arquivosUsuarios/Arquivos.vue